import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';
import es from './locales/es.json';

const langMap = {
  'Francais': 'fr',
  'English': 'en',
  'Espanol': 'es',
};

i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, en: { translation: en }, es: { translation: es } },
  lng: localStorage.getItem('langue') || 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
});

export { langMap };
export default i18n;
